import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {WIDGET_LIST} from '../../widgets/widget-list';
import {BiolinkWidget} from '../../widgets/biolink-widget';
import {Settings} from '@common/core/config/settings.service';
import {FormBuilder} from '@angular/forms';
import {BiolinkEditorService} from '../../biolink-editor.service';
import {Modal} from '@common/core/ui/dialogs/modal.service';
import {CrupdateWidgetDialogData} from '../../widgets/text-widget-modal/text-widget-modal.component';

@Component({
    selector: 'biolink-editor-widget',
    templateUrl: './biolink-editor-widget.component.html',
    styleUrls: ['./biolink-editor-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BiolinkEditorWidgetComponent implements OnInit {
    @Input() widget: BiolinkWidget;

    form = this.fb.group({
        active: true,
    });

    constructor(
        public settings: Settings,
        private fb: FormBuilder,
        public editor: BiolinkEditorService,
        private modal: Modal
    ) {}

    ngOnInit() {
        this.form.patchValue(this.widget);

        this.form.valueChanges.subscribe(value => {
            this.editor.updateContentItemConfig(this.widget, value);
        });
    }

    getWidgetConfig(type: string) {
        return WIDGET_LIST.find(w => w.type === type);
    }

    openEditWidgetDialog(widget: BiolinkWidget) {
        const listItem = this.getWidgetConfig(widget.type);
        this.modal.open(listItem.component, {
            config: widget.config,
            widgetId: widget.id,
        } as CrupdateWidgetDialogData);
    }
}
